// numeric(14,2) viene del backend como string ("2500000.00"). Aceptamos
// también number por conveniencia. Formato CRC con símbolo "₡" y puntos
// como separadores de miles, sin decimales (los céntimos no se muestran
// en producción ganadera — los montos siempre son grandes).
const CURRENCY_FORMATTER = new Intl.NumberFormat("es-CR", {
  style: "currency",
  currency: "CRC",
  maximumFractionDigits: 0,
});

export function formatCurrency(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === "") return "—";
  const num = typeof value === "string" ? Number(value) : value;
  if (!Number.isFinite(num)) return "—";
  return CURRENCY_FORMATTER.format(num);
}
